/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Brands Web API v2
 * OpenAPI spec version: v2
 */

export type SetUpTwoFactorAuthSchemaTwoFactorAuthType = typeof SetUpTwoFactorAuthSchemaTwoFactorAuthType[keyof typeof SetUpTwoFactorAuthSchemaTwoFactorAuthType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetUpTwoFactorAuthSchemaTwoFactorAuthType = {
  Sms: 0,
  Call: 1,
  Email: 2,
  Authenticator: 3,
} as const;
